import React, { Component } from 'react'
import { Container, Grid, Typography } from '@mui/material'

export class TotalBalanceListItem extends Component {
  render() {
    return (
      // <Container style={{ display: "grid", gridTemplateColumns: "auto auto auto", justifyContent: "space-between"}}>
      <>
        <Grid item mr={1.5}>
          <div style={{ display: "flex", alignItems: "start", justifyContent: "start", flexDirection: "column", paddingBottom: "8px" }}>

            <img src={this.props.item.vendorImage} width={25} alt="" />
            {this.props.item.accountVendor}
          </div>
        </Grid>
        <Grid item sx={{ display: "flex", alignItems: "start", justifyContent: "center", flexDirection: "column" }}>
          {this.props.isCurrent ?
            <Typography variant="body1" fontSize={"0.9rem"} fontWeight={500} >
              After Sweep
            </Typography> : null}
          <Typography variant="body1" fontSize={"0.9rem"} fontWeight={500} >
          {this.props.isCurrent ?
            "Actual" : "Balance"}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", alignItems: "end", justifyContent: "center", flexDirection: "column" }}>
          {this.props.isCurrent ?
            <Typography variant="body1" fontWeight={900} fontSize={"0.9rem"}>{this.props.item.balanceAfterSweep}</Typography>
            : null}
          <Typography variant="body1" fontWeight={500} fontSize={"0.9rem"}>{this.props.item.actualBalance}</Typography>

        </Grid>
      </>
      // </Container>
    )
  }
}

export default TotalBalanceListItem